import Bar from "./Bar";
import Card from "../Card";

// Mirrors the dashboard shells rather than showing a stack of generic lines.
// Composable because the three dashboards differ:
//   Company  tileRows={[4, 4]}  charts
//   Admin    tileRows={[5, 4]}  charts
//   Agent    tileRows={[3]}     tableCards={2}

// MobileCard: h-[120px] bg-gray-100, 27% icon column, 73% value + label.
const Tile = () => (
  <div className="flex h-[120px] w-full items-center bg-gray-100">
    <div className="flex h-full w-[27%] items-center justify-center">
      <Bar w={40} h={62} r={6} />
    </div>
    <div className="flex h-full w-[73%] flex-col items-center justify-center gap-2">
      <Bar w={68} h={22} />
      <Bar w={126} h={12} />
    </div>
  </div>
);

// LineChart is a fixed 500x300 with a y-axis, the plot, month ticks, and a
// text-2xl caption beside it.
const ChartBlock = () => (
  <div className="flex w-[50%] items-center gap-4">
    <div className="flex" style={{ width: 500, height: 300 }}>
      <div className="flex w-9 flex-col justify-between py-2">
        {Array.from({ length: 5 }, (_, i) => (
          <Bar key={i} w={22} h={10} />
        ))}
      </div>

      <div className="flex flex-1 flex-col">
        <Bar w="100%" h={250} r={6} />
        <div className="mt-2 flex justify-between">
          {Array.from({ length: 12 }, (_, i) => (
            <Bar key={i} w={18} h={10} />
          ))}
        </div>
      </div>
    </div>

    <div className="flex flex-col gap-2">
      <Bar w={96} h={20} />
      <Bar w={118} h={20} />
      <Bar w={104} h={20} />
    </div>
  </div>
);

// "Recent Listings" / "Recent Buyers": heading + View All, then a small table.
const TableCard = ({ rows = 5 }) => (
  <Card>
    <div className="p-6">
      <div className="mb-6 flex items-center justify-between border-b-2 border-primary pb-2">
        <Bar w={190} h={24} />
        <Bar w={78} h={16} />
      </div>
      <div className="flex flex-col gap-3">
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="flex items-center gap-4">
            <Bar w="28%" h={12} />
            <Bar w="18%" h={12} />
            <Bar w="22%" h={12} />
            <Bar w="14%" h={12} />
          </div>
        ))}
      </div>
    </div>
  </Card>
);

const DashboardSkeleton = ({ tileRows = [4, 4], charts = false, tableCards = 0 }) => (
  <div className="flex flex-col gap-6">
    <Card>
      <div className="p-6">
        {/* "Overview" + Export CSV */}
        <div className="mb-6 flex w-full items-center justify-between border-b-2 border-primary pb-2">
          <Bar w={168} h={30} />
          <Bar w={132} h={36} r={6} />
        </div>

        <div className="flex flex-col gap-4">
          {tileRows.map((count, r) => (
            <div key={r} className="flex flex-row gap-4">
              {Array.from({ length: count }, (_, i) => (
                <Tile key={i} />
              ))}
            </div>
          ))}
        </div>

        {charts && (
          <div className="mt-4 flex">
            <ChartBlock />
            <ChartBlock />
          </div>
        )}
      </div>
    </Card>

    {Array.from({ length: tableCards }, (_, i) => (
      <TableCard key={i} />
    ))}
  </div>
);

export default DashboardSkeleton;
